<div class="details-card-wrapper">
  <div class="details-card">
    <div class="details-card-body">
      <div class="row">
        @for (image of featuredImages(); track image) {
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 feature-image-container">
          <img [src]="image?.url" class="feature-image" />
        </div>
        }
      </div>
    </div>
  </div>
</div>
